import { NgModule } from '@angular/core'
import { provideConfig } from '@spartacus/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TRAINING_LOCATIONS_CONVERTER } from './index'
import { TrainingLocationsConverter } from './training-locations.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        trainingLocationsFeature: {
          module: () => import('./training-locations.module').then((m) => m.TrainingLocationsModule),
          cmsComponents: ['training_locations'],
        },
      }
    }),
    {
      provide: TRAINING_LOCATIONS_CONVERTER,
      useExisting: TrainingLocationsConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        training_locations: TRAINING_LOCATIONS_CONVERTER
      },
      multi: true
    }
  ]
})
export class TrainingLocationsFeatureModule {
}
